// 페이지 전환 애니메이션 설정
export const pageVariants = {
  initial: {
    opacity: 0, // 초기 상태: 투명
  },
  in: {
    opacity: 1, // 진입 상태: 불투명
  },
  out: {
    opacity: 0, // 퇴장 상태: 투명
  },
};

export const pageTransition = {
  type: 'tween', // 트윈 애니메이션 (선형 보간)
  ease: 'easeInOut', // 애니메이션 속도 곡선 (부드럽게 시작하고 끝남)
  duration: 0.5, // 애니메이션 지속 시간 (0.5초)
};

// 필요하다면 다른 공통 애니메이션 설정도 여기에 추가할 수 있습니다.
// 예:
export const fadeIn = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};
